import React from "react";

import { useStoreActions, useStoreState } from 'easy-peasy';
import { Col, Row } from "react-bootstrap";

import PackageFormComponent from "../../components/packages/PackageFormComponent";
import useBackButton from "../../hooks/useBackButton";

const CreatePackagePage = () => {
    const { createPackage } = useStoreActions((actions) => actions.packages);
    const packagesSlugs = useStoreState((state) => state.actionSlugs.actionSlugsDispatcher("packages"));

    const { backButtonComponent } = useBackButton();

    return (
        <div className="container p-2">
            <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                    <h2>Ajout d'une application casque</h2>
                    {backButtonComponent}
                </Col>
            </Row>
            <PackageFormComponent actionFn={createPackage} {...packagesSlugs} />
        </div>
    );
};

export default CreatePackagePage;
